import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/genie/Header';
import HeroSection from '../components/genie/HeroSection';
import WhoItsFor from '../components/genie/WhoItsFor';
import WhatGenieDoes from '../components/genie/WhatGenieDoes';
import ControlLearning from '../components/genie/ControlLearning';
import BeforeAfter from '../components/genie/BeforeAfter';
import AskTally from '../components/genie/AskTally';
import DesignPartner from '../components/genie/DesignPartner';
import Footer from '../components/genie/Footer';
import { FEATURES } from '../config/features';

const Homepage: React.FC = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate(FEATURES.SHOW_WAITLIST ? '/join-waitlist' : '/signup');
  };

  const handleJoinWaitlist = (userType?: string) => {
    const url = userType ? `/join-waitlist?type=${userType}` : '/join-waitlist';
    navigate(url);
  };

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <WhoItsFor />
        <WhatGenieDoes />
        <ControlLearning />
        <BeforeAfter />
        <AskTally />
        <DesignPartner />
      </main>
      <Footer />
    </div>
  );
};

export default Homepage;